import React from 'react'

function Sittings() {
  return (
    <div>Sittings</div>
  )
}

export default Sittings